import { combineReducers } from 'redux'
import akten from './akten'
import dashboard from './dashboard'
import settings from './settings'

export default combineReducers({
    akten,
    dashboard,
    settings,
})